export default "__VITE_ASSET__Bx67GNS$__"